export const SubscriptionsEndpoints = {
  getCustomerSubscriptions: 'getCustomerSubscriptions',
  cancelCustomerSubscription: 'cancelCustomerSubscription',
  getOrderProducts: 'getOrderProducts',
} as const;

export const BASE_SUBSCRIPTIONS_URL = '/v1/stores/subscriptions';
export const GET_CUSTOMER_SUBSCRIPTIONS_URL = `${BASE_SUBSCRIPTIONS_URL}/getSubscriptions`;
export const CANCEL_CUSTOMER_SUBSCRIPTION_URL = `${BASE_SUBSCRIPTIONS_URL}/:subscriptionId/cancel`;
export const GET_ORDER_PRODUCTS_URL = `/v2/orders/:orderId/products`;

export const subscriptionsTags = {
  subscriptionsList: 'subscriptionsList',
} as const;
